import React from 'react';
import classNames from 'classnames';
import { HyperdbListing } from '../../../../hyperdb';

export default HyperdbListing({
  collectionName: 'owners',
  namespace: 'owner',
  mountedUrl: '/owners',
  title: 'Owners',
  columns: [
    { attribute: 'name' },
    { attribute: 'entity.primary_email', label: 'email' },
    { attribute: 'entity.primary_phone', label: 'phone' },
  ],
  useQuickSearch: true,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/owner/containers/Listing.jsx